import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { SandboxStatus } from '@catalyst-psa/shared';

import { api } from '../../api/client.js';

const sandboxKeys = {
  status: ['sandbox', 'status'] as const,
};

/**
 * Public sandbox status. Read once per session (the flag is fixed per environment, so no
 * polling is needed) to drive the training-environment banner.
 */
export function useSandboxStatus(): UseQueryResult<SandboxStatus> {
  return useQuery({
    queryKey: sandboxKeys.status,
    queryFn: () => api.get<SandboxStatus>('/sandbox/status'),
    staleTime: Infinity,
  });
}
